import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 47.996 54.161",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 47.996 54.161\" id=\"icon-play\">\r\n  <path id=\"icon-play_play\" d=\"M26.535,6.006a4,4,0,0,1,6.929,0L56.539,46a4,4,0,0,1-3.465,6H6.926a4,4,0,0,1-3.465-6Z\" transform=\"translate(52 -2.92) rotate(90)\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol